import { FlexService } from "../types/portfolioTypes";

export type FlexContractStatus =
  | "not_generated"
  | "unsigned"
  | "ended"
  | "future"
  | "active"
  | "onboarding";

export type FlexAssetType = "BESS" | "PV curtailment" | "e-boiler";

const PRODUCT_ASSET_MAP: Record<number, FlexAssetType> = {
  1: "BESS",
  2: "BESS",
  3: "BESS",
  4: "e-boiler",
  9: "PV curtailment",
};

// FT-1189 D1 flowchart, ported from yuso-portals-backend
// functions/contractStatus.ts::computeFlexContractStatus — same rule order,
// same exclusive end dates, string-compared "YYYY-MM-DD" dates.
// "not_generated" is a row-presence sentinel (no contracts_flex row), not a
// flowchart status; it must stay because the backend /allservices enricher
// still emits it and call sites branch on it.
export function getFlexContractStatus(service: FlexService): FlexContractStatus {
  if (!service.contract_flex_id) {
    return "not_generated";
  }

  const today = new Date().toLocaleDateString("en-CA"); // local "YYYY-MM-DD"
  const norm = (d: string | null | undefined): string | null =>
    d && d !== "0000-00-00" ? d.slice(0, 10) : null;

  const signatureDate = norm(service.signature_date);
  const startDate = norm(service.start_date);
  const commencementDate = norm(service.commencement_date);
  const endDate = norm(service.end_date);

  if (!signatureDate) return "unsigned";
  if (endDate && today >= endDate) return "ended";
  if (startDate && today < startDate) return "future";
  if (commencementDate && today >= commencementDate) return "active";
  return "onboarding";
}

export function getProductLabelFromId(productId: number): FlexAssetType {
  return PRODUCT_ASSET_MAP[productId] ?? "BESS";
}

export function getFlexAssetType(service: FlexService): FlexAssetType {
  if (service.product && PRODUCT_ASSET_MAP[service.product]) {
    return PRODUCT_ASSET_MAP[service.product];
  }

  const installationId = service.sdp_flex_installation_id || "";
  const lower = installationId.toLowerCase();

  if (lower.includes("bess") || lower.includes("battery")) return "BESS";
  if (lower.includes("pv") || lower.includes("curtailment")) return "PV curtailment";
  if (lower.includes("boiler")) return "e-boiler";

  return "BESS";
}
